export default __webpack_public_path__ + "static/media/Signet of Anarchy.edab9741.jpg";